import ServiceBase from "../services/ServiceBase";
import OperationStatusResponse from '@/models/misc/OperationStatusResponse';

class LogsService extends ServiceBase {
    log(message: string): Promise<OperationStatusResponse> {
        return this.post<OperationStatusResponse>("/api/logs", { message: message } , null)
    }
}

export default new LogsService();